import { getCsrfValue } from "~/common/utils/ApiHelper";
import { getOccTransport } from "~/common/api/occTransport";

interface RequestCartData {
  requestNumber: string;
  tcConsent: boolean;
  ppConsent: boolean;
  marketingConsent: boolean;
  cartId?: string;
  guestCheckoutContext?: string;
}

interface SendCartResponse {
  analytics?: {
    purchaseValueEur?: number;
  };
}

export const requestCart = (data: RequestCartData, signal?: AbortSignal): Promise<SendCartResponse> => {
  const { request, url } = getOccTransport();
  return request(url("/cart/sendCart"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    signal,
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json() as Promise<SendCartResponse>;
    }
  });
};
